import { Brand } from "../configurations";
import { FormattedMessage } from "react-intl";
import { LocalizationMessages } from "../localization/messages";
import { TrackingUtils } from "../utils";
import PropTypes from "prop-types";
import React from "react";
import { SVGIcon2 } from "./common/SVGIconV2";
import { UserContextSelectors } from "../redux/selectors";
import { useSelector } from "react-redux";
import { BrandUtils } from "../utils/brandUtils";
import { useAccountCommunicationHandlers } from "../hooks";

const Challenges = ({ onClick, iconName }) => {
  const brandId = useSelector(UserContextSelectors.brandId);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isMobile = useSelector(UserContextSelectors.isMobile);

  const isPokerClient = BrandUtils.isPokerClient();
  const isClickEnabled = isAuthenticated || isPokerClient;
  const className = isClickEnabled ? "aCchallenges enabled" : "aCchallenges";

  const { openChallengesOrPromotions } = useAccountCommunicationHandlers();

  const handleChallengesClick = () => {
    if (typeof onClick === "function") {
      onClick();
    }
    openChallengesOrPromotions();
    TrackingUtils.sendAnalytics({
      dataCategory: "User Area",
      dataAction: "click",
      dataLabel: "Challenges",
      dataValue: ""
    });
  };

  let challengesTitle = LocalizationMessages.challenges;

  if (brandId === Brand.Sport_Com || brandId === Brand.Sport_DE) {
    challengesTitle = isMobile
      ? LocalizationMessages.challenges_brand_8_mobile
      : LocalizationMessages.challenges_brand_8;
  }

  return (
    <a
      className={className}
      onClick={handleChallengesClick}
      data-testid="uc-my-account-area-challenges"
    >
      <div className="aCchallengesIndicator">
        <div className="aCchallengesIndicatorBadge" />
      </div>
      <SVGIcon2 iconName={iconName} />

      <div className="aCchallengesTitle">
        <FormattedMessage {...challengesTitle} />
      </div>
    </a>
  );
};

Challenges.propTypes = {
  onClick: PropTypes.func,
  iconName: PropTypes.string
};

export default React.memo(Challenges);
